export default __webpack_public_path__ + "files/phos_trend_station_data_20years-eecc9e76f385b4ccb933113506178b51.json";